import React from 'react';
import { colors } from 'seedling/constants';

const DownloadIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 25 25"
  >
    <path
      fill={props.color}
      d="M13.35,13.8138208 L13.35,4.94616317 C13.35,4.47672113 12.969442,4.09616317 12.5,4.09616317 C12.030558,4.09616317 11.65,4.47672113 11.65,4.94616317 L11.65,13.7315625 L9.32506531,11.5009587 C8.98631873,11.1759563 8.44824384,11.1870981 8.12324141,11.5258447 C7.79823898,11.8645913 7.80938082,12.4026662 8.14812741,12.7276686 L11.9543995,16.3795067 C12.2832697,16.6950334 12.8024672,16.6950334 13.1313374,16.3795067 L16.9376095,12.7276686 C17.2763561,12.4026662 17.2874979,11.8645913 16.9624955,11.5258447 C16.6374931,11.1870981 16.0994182,11.1759563 15.7606716,11.5009587 L13.35,13.8138208 Z M5.38903109,18.7 C4.91958905,18.7 4.53903109,18.319442 4.53903109,17.85 C4.53903109,17.380558 4.91958905,17 5.38903109,17 L19.6143236,17 C20.0837656,17 20.4643236,17.380558 20.4643236,17.85 C20.4643236,18.319442 20.0837656,18.7 19.6143236,18.7 L5.38903109,18.7 Z"
    />
  </svg>
);

DownloadIcon.defaultProps = {
  color: colors.darkestGrey,
  width: '20px',
  height: '20px',
};

export default DownloadIcon;
